<template>
    <span class="text-xs text-wrap font-normal leading-[16.94px]" :class="{
        'text-[#16a249]': item.isSuccessful && item.isRegistered,
        'text-[#EF5253]': !item.isSuccessful,
        'text-[#FD881E]': item.isSuccessful && !item.isRegistered
    }">
        {{ shortenedMessage }}
    </span>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            required: true
        },
        wordLimit: {
            type: Number,
            default: 20
        }
    },
    computed: {
        shortenedMessage() {
            if (!this.item.message) return '';

            const words = this.item.message.split(' ');

            if (words.length <= this.wordLimit) {
                return this.item.message;
            }

            return words.slice(0, this.wordLimit).join(' ') + '...';
        }
    }
}
</script>